module.exports = __webpack_public_path__ + "static/media/aristamd_stacked.220287c6.svg";